/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchFacilitiesResponse } from './search-facilities-response';


export interface SearchFacilitiesResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchFacilitiesResponse> | null;
}

